export enum ActionType {
  // creatte user
  SEND_MINI_NOTIFICATION = "action/SEND_MINI_NOTIFICATION",
  SEND_MINI_NOTIFICATION_SUCCESS = "action/SEND_MINI_NOTIFICATION_SUCCESS",
  SEND_MINI_NOTIFICATION_ERROR = "action/SEND_MINI_NOTIFICATION_ERROR",
  RESET_SEND_MINI_NOTIFICATION = "action/RESET_SEND_MINI_NOTIFICATION",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface SendMiniStressNotificationData {
  user_ids?: string;
  short_text: string;
  notification_text: string;
}
